export const VERSION = "v50.1-3dbfbd210";
export const SCM_REVISION = "3dbfbd210234e68a29dfb7d2c22167cc0f3e662c";